import { render, staticRenderFns } from "./BaseFormNewController.vue?vue&type=template&id=562b4fde"
import script from "./BaseFormNewController.vue?vue&type=script&lang=js"
export * from "./BaseFormNewController.vue?vue&type=script&lang=js"
import style0 from "./BaseFormNewController.vue?vue&type=style&index=0&id=562b4fde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports